import React, { useEffect, useState } from "react";
import { fetchData } from "../../Components/common/utils";
import { NavLink, useParams } from "react-router-dom";
import MainLoader from "../../Components/MainLoader";

function AllAd() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [latestProducts, setLatestProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const { id } = useParams();

  useEffect(() => {
    const fetchApiData = async () => {
      try {
        const url = "api/get/all/adds";
        const result = await fetchData(url);

        if (result?.data) {
          const sortedData = [...result.data].sort(
            (a, b) =>
              new Date(b.updated_at || 0) - new Date(a.updated_at || 0)
          );

          setData(sortedData);
          setFilteredData(sortedData);

          // extract categories
          const categoryList = [
            "All",
            ...new Set(
              result.data.map((item) => item.category?.title || "Uncategorized")
            ),
          ];
          setCategories(categoryList);

          // Feature Ads (all by default)
          const featuread = result.data.filter(
            (item) => String(item.feature) === "1"
          );
          setLatestProducts(featuread);
        }
      } catch (error) {
        console.error("Error fetching ads:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchApiData();
  }, []);

  // Handle category filter
  useEffect(() => {
    if (selectedCategory === "All") {
      setFilteredData(data);
      const featuread = data.filter((item) => String(item.feature) === "1");
      setLatestProducts(featuread);
    } else {
      const categoryFiltered = data.filter(
        (item) =>
          (item.category?.title || "Uncategorized") === selectedCategory
      );
      setFilteredData(categoryFiltered);
      const featuread = categoryFiltered.filter(
        (item) => String(item.feature) === "1"
      );
      setLatestProducts(featuread);
    }
  }, [selectedCategory, data]);

  // Handle search filter
  useEffect(() => {
    if (!searchQuery.trim()) {
      if (selectedCategory === "All") {
        setFilteredData(data);
      } else {
        setFilteredData(
          data.filter(
            (item) =>
              (item.category?.title || "Uncategorized") === selectedCategory
          )
        );
      }
    } else {
      const filtered = data.filter(
        (item) =>
          item.title?.toLowerCase().includes(searchQuery.toLowerCase()) &&
          (selectedCategory === "All" ||
            (item.category?.title || "Uncategorized") === selectedCategory)
      );
      setFilteredData(filtered);
    }
  }, [searchQuery, selectedCategory, data]);

  return (
    <div className="mt-4">
      {loading && <MainLoader />}
      {!loading && data.length === 0 ? (
        <div className="container">
          <div className="text-center no-found-text">
            <h3>Sorry! No Ad Found.</h3>
          </div>
        </div>
      ) : (
        <div className="container">
          {/* Header */}
          <div className="mt-4">
            <div className="brand-banner py-5 px-3 text-center text-white mb-4">
              <h1 className="display-4 fw-bold mb-2">
                Smart Ads <span className="brand-name">Simple Choices</span>
              </h1>
              <p className="lead">
                Browse the latest ads, deals, and listings. Post your ad free
                and reach buyers fast.
              </p>
            </div>
          </div>

          {/* Categories Tabs */}
          {categories.length > 0 && (
            <div className="d-flex align-items-center flex-wrap justify-content-center gap-2 my-5">
              {categories.map((category, index) => (
                <button
                  key={index}
                  className={`tabs-btns ${
                    selectedCategory === category ? "active" : ""
                  }`}
                  onClick={() => setSelectedCategory(category)}
                >
                  {category}
                </button>
              ))}
            </div>
          )}

          {/* Feature Ads */}
          {latestProducts.length > 0 && (
            <>
              <h2 className="my-4">Featured Ads</h2>
              <div className="row">
                {latestProducts.map((details, index) => (
                  <div className="col-md-3 mb-3" key={index}>
                    <NavLink to={`/${details.slug || "#"}`}>
                      <div className="card h-100">
                        <div className="card-img-wrapper">
                          <img
                            className="latest-product-img"
                            src={
                              details.media?.[0]?.original_url ||
                              "https://via.placeholder.com/400x300?text=No+Image"
                            }
                            alt={details.title}
                          />
                        </div>
                        <div className="card-body">
                          <h6 className="card-title text-center">
                            {details.title}
                          </h6>
                          <p className="small product-card-description line-clamp-3">
                            {details.short_description || "No description"}
                          </p>
                          <strong className="dollar ">
                            {details.email || "N/A"}
                          </strong>
                        </div>
                      </div>
                    </NavLink>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* All Ads */}
          <div className="row my-4">
            <div className="col-md-6 mt-2">
              <h2>
                {selectedCategory === "All"
                  ? "All Ads"
                  : `${selectedCategory} Ads`}
              </h2>
            </div>
            <div className="col-md-6 mt-2">
              <input
                type="text"
                className="form-control"
                placeholder="Search by name..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          <div className="row">
            {filteredData.map((details, index) => (
              <div className="col-md-3 mb-3" key={index}>
                <NavLink to={`/${details.slug || "#"}`}>
                  <div className="card h-100">
                    <div className="card-img-wrapper">
                      <img
                        className="latest-product-img"
                        src={
                          details.media?.[0]?.original_url ||
                          "https://via.placeholder.com/400x300?text=No+Image"
                        }
                        alt={details.title}
                      />
                    </div>
                    <div className="card-body">
                      <h6 className="card-title text-center">
                        {details.title}
                      </h6>
                      <p className="small product-card-description line-clamp-3">
                        {details.short_description || "No description"}
                      </p>
                      <strong className="dollar ">
                        {details.email || "N/A"}
                      </strong>
                    </div>
                  </div>
                </NavLink>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default AllAd;
